import * as React from 'react';
import {DeleteOutline, ExpandMore} from '@material-ui/icons';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormLabel,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from '@material-ui/core';
import {getIn} from 'formik';
import {formatDate} from '../utils/formatDate';
import request from 'superagent';
import ConfirmDelete from './ConfirmDelete';

export const getviaCepUrl = (postal_code = '', handleFormikValues, index) => {
  const cepWithoutHifen = postal_code.replace(/-/g, '');
  if (cepWithoutHifen.length === 8) {
    let next_address = request.get(
      `https://viacep.com.br/ws/${postal_code}/json`,
    );
    next_address.end((err, response) => {
      if (err) {
        console.log(err);
      } else {
        if (response.body) {
          const {logradouro, cep, localidade, bairro, uf} = response.body;
          handleFormikValues.setFieldValue(
            `contacts[${index}].postalCode`,
            cep,
          );
          handleFormikValues.setFieldValue(
            `contacts[${index}].street`,
            `${logradouro}`,
          );
          handleFormikValues.setFieldValue(
            `contacts[${index}].city`,
            localidade,
          );
          handleFormikValues.setFieldValue(`contacts[${index}].state`, uf);
          handleFormikValues.setFieldValue(
            `contacts[${index}].neighborhood`,
            bairro,
          );
          handleFormikValues.setFieldValue(
            `contacts[${index}].country`,
            'Brasil',
          );
        }
      }
    });
  }
};

export default function AccordionItem({
  formikProps,
  errors,
  contact,
  index,
  onRemove,
}) {
  const onDeleteContact = async () => {
    const res = await ConfirmDelete(
      'Você perderá todos os dados deste contato. Deseja realmente excluir?',
    );
    if (res) {
      onRemove();
    }
  };
  return (
    <div style={{display: 'flex', alignItems: 'center'}}>
      <Accordion style={{marginTop: 15, width: '95%'}}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel1-content"
          id="panel1-header">
          <FormLabel
            component="legend"
            style={{
              color: formikProps.errors.contacts ? 'red' : undefined,
            }}>
            Contato {index + 1} - {contact.name || 'Sem nome'} -{' '}
            {contact.department}
          </FormLabel>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={1}>
            {/* Código do Cliente */}
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                label="Nome Completo *"
                name={`contacts[${index}].name`}
                value={contact.name}
                onChange={formikProps.handleChange}
                fullWidth
                variant="outlined"
                margin="none"
                helperText={
                  formikProps.touched.contacts?.[index]?.name &&
                  formikProps.errors.contacts?.[index]?.name
                }
                error={
                  formikProps.touched.contacts?.[index]?.name &&
                  Boolean(formikProps.errors.contacts?.[index]?.name)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="Apelido"
                name={`contacts[${index}].nickname`}
                value={contact.nickname}
                onChange={formikProps.handleChange}
                fullWidth
                variant="outlined"
                margin="none"
                helperText={
                  formikProps.touched.contacts?.[index]?.nickname &&
                  formikProps.errors.contacts?.[index]?.nickname
                }
                error={
                  formikProps.touched.contacts?.[index]?.nickname &&
                  Boolean(formikProps.errors.contacts?.[index]?.nickname)
                }
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="Departamento *"
                name={`contacts[${index}].department`}
                value={contact.department}
                onChange={formikProps.handleChange}
                fullWidth
                variant="outlined"
                margin="none"
                helperText={
                  formikProps.touched.contacts?.[index]?.department &&
                  formikProps.errors.contacts?.[index]?.department
                }
                error={
                  formikProps.touched.contacts?.[index]?.department &&
                  Boolean(formikProps.errors.contacts?.[index]?.department)
                }
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Cargo"
                name={`contacts[${index}].role`}
                value={contact.role}
                onChange={formikProps.handleChange}
                fullWidth
                variant="outlined"
                margin="none"
                helperText={
                  formikProps.touched.contacts?.[index]?.role &&
                  formikProps.errors.contacts?.[index]?.role
                }
                error={
                  formikProps.touched.contacts?.[index]?.role &&
                  Boolean(formikProps.errors.contacts?.[index]?.role)
                }
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="CPF"
                name={`contacts[${index}].cpf`}
                value={contact.cpf}
                onChange={formikProps.handleChange}
                fullWidth
                variant="outlined"
                margin="none"
                helperText={
                  formikProps.touched.contacts?.[index]?.cpf &&
                  formikProps.errors.contacts?.[index]?.cpf
                }
                error={
                  formikProps.touched.contacts?.[index]?.cpf &&
                  Boolean(formikProps.errors.contacts?.[index]?.cpf)
                }
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="RG"
                name={`contacts[${index}].rg`}
                value={contact.rg}
                onChange={formikProps.handleChange}
                fullWidth
                variant="outlined"
                margin="none"
                helperText={
                  formikProps.touched.contacts?.[index]?.rg &&
                  formikProps.errors.contacts?.[index]?.rg
                }
                error={
                  formikProps.touched.contacts?.[index]?.rg &&
                  Boolean(formikProps.errors.contacts?.[index]?.rg)
                }
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Telefone 1 *"
                name={`contacts[${index}].phone1`}
                value={contact.phone1}
                onChange={formikProps.handleChange}
                fullWidth
                variant="outlined"
                margin="none"
                helperText={
                  formikProps.touched.contacts?.[index]?.phone1 &&
                  formikProps.errors.contacts?.[index]?.phone1
                }
                error={
                  formikProps.touched.contacts?.[index]?.phone1 &&
                  Boolean(formikProps.errors.contacts?.[index]?.phone1)
                }
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Telefone 2"
                name={`contacts[${index}].phone2`}
                value={contact.phone2}
                onChange={formikProps.handleChange}
                fullWidth
                variant="outlined"
                margin="none"
                helperText={
                  formikProps.touched.contacts?.[index]?.phone2 &&
                  formikProps.errors.contacts?.[index]?.phone2
                }
                error={
                  formikProps.touched.contacts?.[index]?.phone2 &&
                  Boolean(formikProps.errors.contacts?.[index]?.phone2)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Whatsapp *"
                name={`contacts[${index}].whatsapp`}
                value={contact.whatsapp}
                onChange={formikProps.handleChange}
                fullWidth
                variant="outlined"
                margin="none"
                helperText={
                  formikProps.touched.contacts?.[index]?.whatsapp &&
                  formikProps.errors.contacts?.[index]?.whatsapp
                }
                error={
                  formikProps.touched.contacts?.[index]?.whatsapp &&
                  Boolean(formikProps.errors.contacts?.[index]?.whatsapp)
                }
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <TextField
                label="E-mail *"
                name={`contacts[${index}].email`}
                value={contact.email}
                onChange={formikProps.handleChange}
                fullWidth
                variant="outlined"
                margin="none"
                helperText={
                  formikProps.touched.contacts?.[index]?.email &&
                  formikProps.errors.contacts?.[index]?.email
                }
                error={
                  formikProps.touched.contacts?.[index]?.email &&
                  Boolean(formikProps.errors.contacts?.[index]?.email)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                label="E-mail para login (App MeditaBem) *"
                name={`contacts[${index}].emailLogin`}
                value={contact.emailLogin}
                onChange={formikProps.handleChange}
                fullWidth
                variant="outlined"
                margin="none"
                helperText={
                  formikProps.touched.contacts?.[index]?.emailLogin &&
                  formikProps.errors.contacts?.[index]?.emailLogin
                }
                error={
                  formikProps.touched.contacts?.[index]?.emailLogin &&
                  Boolean(formikProps.errors.contacts?.[index]?.emailLogin)
                }
              />
            </Grid>

            {/* Endereço */}
            <Grid item xs={12} sm={6} md={2}>
              <TextField
                fullWidth
                margin="none"
                variant="outlined"
                id="postalCode"
                label="CEP"
                name={`contacts[${index}].postalCode`}
                value={contact.postalCode}
                onChange={e => {
                  const cep = e.target.value;
                  getviaCepUrl(cep, formikProps, index);
                  formikProps.setFieldValue(
                    `contacts[${index}].postalCode`,
                    cep,
                  );
                  formikProps.setFieldError(
                    `contacts[${index}].postalCode`,
                    '',
                  );
                }}
                helperText={
                  getIn(formikProps.touched, `contacts[${index}].postalCode`) &&
                  getIn(formikProps.errors, `contacts[${index}].postalCode`)
                }
                error={
                  errors &&
                  errors[index]?.postalCode &&
                  Boolean(errors[index]?.postalCode)
                }
              />
            </Grid>

            <Grid item xs={12} sm={8} md={8}>
              <TextField
                fullWidth
                margin="none"
                variant="outlined"
                id="street"
                label="Logradouro"
                name={`contacts[${index}].street`}
                value={contact.street}
                onChange={formikProps.handleChange}
                helperText={errors && errors[index]?.street}
                error={
                  errors &&
                  errors[index]?.street &&
                  Boolean(errors[index]?.street)
                }
              />
            </Grid>

            <Grid item xs={12} sm={4} md={2}>
              <TextField
                fullWidth
                type="number"
                margin="none"
                variant="outlined"
                id="number"
                label="Número"
                name={`contacts[${index}].number`}
                value={contact.number}
                onChange={formikProps.handleChange}
                helperText={errors && errors[index]?.number}
                error={
                  errors &&
                  errors[index]?.number &&
                  Boolean(errors[index]?.number)
                }
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <TextField
                fullWidth
                margin="none"
                variant="outlined"
                id="neighborhood"
                label="Bairro"
                value={contact.neighborhood}
                name={`contacts[${index}].neighborhood`}
                onChange={formikProps.handleChange}
                helperText={errors && errors[index]?.neighborhood}
                error={
                  errors &&
                  errors[index]?.neighborhood &&
                  Boolean(errors[index]?.neighborhood)
                }
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                margin="none"
                variant="outlined"
                id="city"
                label="Cidade"
                name={`contacts[${index}].city`}
                value={contact.city}
                onChange={formikProps.handleChange}
                helperText={errors && errors[index]?.city}
                error={
                  errors && errors[index]?.city && Boolean(errors[index]?.city)
                }
              />
            </Grid>

            <Grid item xs={12} sm={6} md={1}>
              <TextField
                fullWidth
                margin="none"
                variant="outlined"
                id="state"
                label="Estado"
                name={`contacts[${index}].state`}
                value={contact.state}
                onChange={formikProps.handleChange}
                helperText={errors && errors[index]?.state}
                error={
                  errors &&
                  errors[index]?.state &&
                  Boolean(errors[index]?.state)
                }
              />
            </Grid>

            <Grid item xs={12} sm={6} md={1}>
              <TextField
                fullWidth
                margin="none"
                variant="outlined"
                id="country"
                label="País"
                name={`contacts[${index}].country`}
                value={contact.country}
                onChange={formikProps.handleChange}
                helperText={errors && errors[index]?.country}
                error={
                  errors &&
                  errors[index]?.country &&
                  Boolean(errors[index]?.country)
                }
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                minRows={3}
                margin="none"
                variant="outlined"
                id="contactObservation"
                name="contactObservation"
                label="Observações"
                value={formikProps.values.contactObservation}
                onChange={formikProps.handleChange}
                helperText={
                  formikProps.touched.contactObservation &&
                  formikProps.errors.contactObservation
                }
                error={
                  formikProps.touched.contactObservation &&
                  Boolean(formikProps.errors.contactObservation)
                }
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <IconButton edge="end" aria-label="delete" onClick={onDeleteContact}>
        <DeleteOutline />
      </IconButton>
    </div>
  );
}

export function AccordionCustom({defaultExpanded, title, errors, children}) {
  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      border="none"
      style={{width: '100%', border: 'none', paddingTop: 30}}>
      <AccordionSummary
        style={{border: 'none'}}
        expandIcon={<ExpandMore />}
        aria-controls="panel1-content"
        id="panel1-header">
        <Typography
          component="h5"
          variant="h5"
          style={{
            color: errors ? 'red' : undefined,
          }}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails style={{border: 'none'}}>{children}</AccordionDetails>
    </Accordion>
  );
}

const PlanContracted = ({index, formikProps, errors}) => {
  const values = formikProps?.values?.plans[index] || {};
  const touched = formikProps?.touched?.plans?.[index] || {};
  const fieldErrors = formikProps?.errors?.plans?.[index] || {};

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography component="h6" variant="h6">
          {values.title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          {/* <Grid item xs={12}>
            <FormControl
              component="fieldset"
              error={touched.planType && Boolean(fieldErrors.planType)}>
              <Typography variant="subtitle1">Tipo de Plano</Typography>
              <RadioGroup
                row
                name={`plans[${index}].planType`}
                value={values.planType || ''}
                onChange={formikProps.handleChange}>
                <FormControlLabel
                  value="mensal"
                  control={<Radio />}
                  label="Mensal"
                />
                <FormControlLabel
                  value="anual"
                  control={<Radio />}
                  label="Anual"
                />
              </RadioGroup>
              {touched.planType && fieldErrors.planType && (
                <FormHelperText>{fieldErrors.planType}</FormHelperText>
              )}
            </FormControl>
          </Grid> */}

          {[
            {label: 'Status', value: 'status'},
            {label: 'Data início do plano', value: 'planDate'},
            {label: 'Valor full R$', value: 'valueFull'},
            {label: 'Valor contratado R$', value: 'value'},
            {label: 'Desconto (Valor)', value: 'discount'},
            {label: 'Desconto (%)', value: 'percentageDiscount'},
            {label: 'Data de Vigência', value: 'validity'},
          ].map(({label, value}, i) => (
            <Grid item xs={12} sm={6} md={2} key={i}>
              {value === 'status' ? (
                <TextField
                  select
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{shrink: true}}
                  name={`plans[${index}].${value}`}
                  label={label}
                  value={values[value] || ''}
                  onChange={formikProps.handleChange}
                  error={touched[value] && Boolean(fieldErrors[value])}
                  helperText={touched[value] && fieldErrors[value]}>
                  {[
                    {value: 'Active', label: 'Ativo'},
                    {value: 'Inactive', label: 'Inativo'},
                  ].map(option => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              ) : (
                <TextField
                  fullWidth
                  variant="outlined"
                  type={label.includes('Data') ? 'date' : 'text'}
                  InputLabelProps={{shrink: true}}
                  name={`plans[${index}].${value}`}
                  label={label}
                  value={
                    value === 'validity' || value === 'planDate'
                      ? formatDate(values[value])
                      : values[value] || ''
                  }
                  onChange={formikProps.handleChange}
                  error={touched[value] && Boolean(fieldErrors[value])}
                  helperText={touched[value] && fieldErrors[value]}
                />
              )}
            </Grid>
          ))}

          <Grid item xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              multiline
              minRows={3}
              name={`plans[${index}].commercialNotes`}
              label="Observações"
              value={values.commercialNotes || ''}
              onChange={formikProps.handleChange}
              error={
                touched.commercialNotes && Boolean(fieldErrors.commercialNotes)
              }
              helperText={
                touched.commercialNotes && fieldErrors.commercialNotes
              }
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              multiline
              minRows={3}
              name={`plans[${index}].additionalServices`}
              label="Acordos comerciais e serviços adicionais contratados"
              value={values.additionalServices || ''}
              onChange={formikProps.handleChange}
              error={
                touched.additionalServices &&
                Boolean(fieldErrors.additionalServices)
              }
              helperText={
                touched.additionalServices && fieldErrors.additionalServices
              }
            />
          </Grid>

          {/* Financeiro */}
          <div style={{width: '100%', marginTop: 20, margin: 10}}>
            <Typography component="h6" variant="h6">
              Financeiro
            </Typography>
          </div>
          <Grid item xs={12} md={3}>
            <TextField
              select
              fullWidth
              margin="none"
              variant="outlined"
              name={`plans[${index}].paymentMethod`}
              label="Forma de pagamento"
              value={values.paymentMethod || ''}
              onChange={formikProps.handleChange}
              error={
                touched.paymentMethod && Boolean(fieldErrors.paymentMethod)
              }
              helperText={touched.paymentMethod && fieldErrors.paymentMethod}>
              {[
                'Boleto bancário',
                'Cartão de crédito',
                'Transferência bancária',
                'Dinheiro/Cheque',
                'Permuta',
                'Mista',
              ].map(option => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              select
              fullWidth
              margin="none"
              variant="outlined"
              name={`plans[${index}].billingType`}
              label="Tipo de faturamento"
              value={values.billingType || ''}
              onChange={formikProps.handleChange}
              error={touched.billingType && Boolean(fieldErrors.billingType)}
              helperText={touched.billingType && fieldErrors.billingType}>
              {['À vista', 'Parcelado', 'Mensal', 'Anual'].map(option => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              margin="none"
              variant="outlined"
              type="text"
              name={`plans[${index}].invoiceIssueDate`}
              label="Data para emissão de NF"
              InputLabelProps={{shrink: true}}
              value={values.invoiceIssueDate || ''}
              onChange={formikProps.handleChange}
              error={
                touched.invoiceIssueDate &&
                Boolean(fieldErrors.invoiceIssueDate)
              }
              helperText={
                touched.invoiceIssueDate && fieldErrors.invoiceIssueDate
              }
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              margin="none"
              variant="outlined"
              type="text"
              name={`plans[${index}].dueDate`}
              label="Data de vencimento"
              InputLabelProps={{shrink: true}}
              value={values.dueDate || ''}
              onChange={formikProps.handleChange}
              error={touched.dueDate && Boolean(fieldErrors.dueDate)}
              helperText={touched.dueDate && fieldErrors.dueDate}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              margin="none"
              variant="outlined"
              multiline
              minRows={3}
              name={`plans[${index}].billingRules`}
              label="Regras de faturamento"
              value={values.billingRules || ''}
              onChange={formikProps.handleChange}
              error={touched.billingRules && Boolean(fieldErrors.billingRules)}
              helperText={touched.billingRules && fieldErrors.billingRules}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              margin="none"
              variant="outlined"
              multiline
              minRows={3}
              name={`plans[${index}].paymentHistory`}
              label="Controle financeiro"
              value={values.paymentHistory || ''}
              onChange={formikProps.handleChange}
              error={
                touched.paymentHistory && Boolean(fieldErrors.paymentHistory)
              }
              helperText={touched.paymentHistory && fieldErrors.paymentHistory}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              margin="none"
              variant="outlined"
              multiline
              minRows={3}
              name={`plans[${index}].financialObservation`}
              label="Observações"
              value={values.financialObservation || ''}
              onChange={formikProps.handleChange}
              error={
                touched.financialObservation &&
                Boolean(fieldErrors.financialObservation)
              }
              helperText={
                touched.financialObservation && fieldErrors.financialObservation
              }
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export function PlansForm({formikProps, errors}) {
  return (
    <>
      {Array.from({length: 9}, (_, index) => (
        <PlanContracted
          key={index}
          index={index}
          formikProps={formikProps}
          errors={errors}
        />
      ))}
    </>
  );
}
